var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Popper',{attrs:{"options":{
      placement: _vm.placement,
    },"visible-arrow":true,"trigger":_vm.trigger}},[_c('div',{staticClass:"bg-black border-0 popper"},[_c('div',{staticClass:"popper__body"},[_vm._t("default")],2)]),_vm._v(" "),_c('div',{staticClass:"text-white",attrs:{"slot":"reference"},slot:"reference"},[_vm._t("reference")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }